import React, { createContext, FC, useContext } from 'react'
import { useBookableShipmentAuctionSearch } from '../hooks/useBookableShipmentAuctionSearch'

export interface IBookableShipmentAuctionSearchContext
  extends ReturnType<typeof useBookableShipmentAuctionSearch> {}

export const BookableShipmentAuctionSearchContext = createContext<
  IBookableShipmentAuctionSearchContext
>({
  getBookableAuctionShipments: async () => {},
  totalCount: 0,
  isLoading: false,
  auctionShipments: [],
})

export const BookableShipmentAuctionSearchProvider: FC = ({ children }) => {
  const state = useBookableShipmentAuctionSearch()
  return (
    <BookableShipmentAuctionSearchContext.Provider value={state}>
      {children}
    </BookableShipmentAuctionSearchContext.Provider>
  )
}

export const useBookableShipmentAuctionSearchContext = () =>
  useContext(BookableShipmentAuctionSearchContext)
